import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  // ✅ Load cart items from localStorage on init
  useEffect(() => {
    const stored = localStorage.getItem("cartItems");
    if (stored) {
      const parsed = JSON.parse(stored);
      setCartItems(parsed);
      setCartCount(parsed.length);
    }
  }, []);

  // ✅ Update localStorage whenever cartItems change
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
    setCartCount(cartItems.length);
  }, [cartItems]);

  const addToCart = (item, quantity = 1, choices = [], note = "") => {
    const existing = cartItems.find(
      (i) => i.item?.id === item.id && JSON.stringify(i.choices) === JSON.stringify(choices)
    );

    if (existing) {
      setCartItems((prev) =>
        prev.map((ci) =>
          ci === existing
            ? { ...ci, quantity: ci.quantity + quantity }
            : ci
        )
      );
    } else {
      const basePrice = parseFloat(item.price || 0);
      const choicePrice = choices.reduce(
        (sum, c) => sum + parseFloat(c.price || 0),
        0
      );

      setCartItems((prev) => [
        ...prev,
        {
          id: Date.now(),
          item,
          quantity,
          choices,
          note,
          locked_price: (basePrice * quantity).toFixed(2),
          locked_choice_price: (choicePrice * quantity).toFixed(2),
        },
      ]);
    }
  };

  const removeFromCart = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("cartItems");
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        setCartItems,
        addToCart,
        removeFromCart,
        clearCart,
        cartCount,
        setCartCount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
